export default {
	listGames: state => state.topGames,
	listHomes: state => state.topHomes,
	getLang: state => state.languages,
	getUserInfo: state => state.userInfo,
	getUrl: state => state.urlImage,
	getInapp: state => state.urlInapp,
	getEntry: state => state.userInfo.entry,
	getHistory: state => state.history,
	getLocale: state => state.userInfo.locale,
	getApiGender: state => state.apiGender,
	getContents: state => state.contents,
	getGender: state => state.gender,
	getFastAds: state => state.fastAds
}